import React, { useEffect, useState } from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { useParams } from 'react-router-dom'
import { formatDateonly, Get_Api } from '../ApiUrls';

function Blogdetails() {
    const { id } = useParams();

    const [IsUploading, setIsUploading] = useState(false);
    const [Blogdetail, setBlogdetail] = useState({});

    const GetAllBlogdetail = async () => {
        try {
            setIsUploading(true)
            const response = await Get_Api(`api/admin/GetABlogDetails/${id}`)
            setBlogdetail(response?.data)
            setIsUploading(false)
        } catch (error) {
            setIsUploading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        GetAllBlogdetail();
    }, [id]);

    return (
        <>
            <Navbar />
            <div className="Properties-header">
                <h1>Blog Details</h1>
                <p>
                    Home / <span className="active">Blog Details</span>
                </p>
            </div>
            <div className="blog-content">
                <div className="main-content">
                    <img
                        src={Blogdetail?.Image}
                        alt="Blog"
                        className="detailblog-image"
                    />
                    <div className="blog-meta">
                        <p>{formatDateonly(Blogdetail?.createdAt)}</p>
                    </div>
                    <h2>{Blogdetail?.Name}</h2>
                    <p>
                        {Blogdetail?.Detail}
                    </p>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default Blogdetails